module.exports = __webpack_public_path__ + "static/media/ic_nav_setting.98840bb0.svg";